import styled from "styled-components";

export const PatientForm = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    padding: 40px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    &__left {
      .title {
        font-family: "Nunito Sans Light";
        font-size: 25px;
        color: #3e3e5b;
      }
      .subtitle {
        font-size: 19px;
        color: #1f1f52;
      }
    }
    &__right {
      .icon {
        font-size: 44px;
        color: #d3eaff;
      }
    }
  }
  .id-verification {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .inputs {
      padding: 20px;
    }
  }
  .form-new-patient {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .form {
      display: flex;
      flex-direction: column;
      height: 100%;
      .inputs {
        flex: 1;
        padding: 20px;
        overflow-y: auto;
        .input {
          margin-bottom: 20px;
          &:first-child {
            margin-bottom: 0px;
          }
        }
      }
    }
  }
  .buttons {
    background: #e9e9f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
    margin-top: auto;
    box-sizing: border-box;
    display: flex;
    .cancel-button {
      margin-right: 20px;
    }
    .continue-button {
      flex: 1;
    }
  }
`;
